import { render, staticRenderFns } from "./ModalCompanyHoliday.vue?vue&type=template&id=036e610a"
import script from "./ModalCompanyHoliday.vue?vue&type=script&lang=js"
export * from "./ModalCompanyHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports